export default function Awards() {
  const awards = [
    {
      type: 'Ouro',
      color: 'from-amber-400 to-amber-600',
      icon: 'ri-medal-line',
      description: 'Medalhas de ouro em concursos nacionais e internacionais de queijos artesanais'
    },
    {
      type: 'Prata',
      color: 'from-gray-300 to-gray-500',
      icon: 'ri-medal-line',
      description: 'Reconhecimento pela qualidade e inovação em derivados lácteos de cabra'
    },
    {
      type: 'Bronze',
      color: 'from-orange-400 to-orange-600',
      icon: 'ri-medal-line',
      description: 'Premiações regionais destacando a excelência da produção do Cariri'
    }
  ];

  return (
    <section id="premiacoes" className="py-8 md:py-20 bg-gradient-to-b from-amber-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Premiações</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-3 md:mb-6"></div>
          <p className="text-sm md:text-xl text-gray-700 max-w-3xl mx-auto">
            Nossos queijos conquistaram reconhecimento nacional e internacional, com medalhas de ouro, prata e bronze em prestigiados concursos
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-4 md:gap-8 max-w-5xl mx-auto mb-8 md:mb-16">
          {awards.map((award, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-lg p-5 md:p-8 text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className={`w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br ${award.color} rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 shadow-lg`}>
                <i className={`${award.icon} text-3xl md:text-5xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-green-800 mb-2 md:mb-4">Medalha de {award.type}</h3>
              <p className="text-xs md:text-base text-gray-700 leading-relaxed">{award.description}</p>
            </div>
          ))}
        </div>
        
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="p-6 md:p-10 flex flex-col justify-center">
                <div className="flex items-center mb-4 md:mb-6">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-amber-500 rounded-full flex items-center justify-center mr-3 md:mr-4">
                    <i className="ri-trophy-line text-2xl md:text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl md:text-3xl font-bold text-green-800">Excelência Reconhecida</h3>
                </div>
                <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6">
                  A qualidade dos nossos queijos de leite de cabra tem sido reconhecida em diversos concursos nacionais, regionais e internacionais. Cada premiação representa o compromisso da Agubel com a excelência, a tradição e a inovação.
                </p>
                <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
                  Essas conquistas são resultado do trabalho dedicado de mais de 150 famílias de agricultores familiares do Cariri paraibano, que produzem com amor e cuidado cada litro de leite que se transforma em nossos produtos premiados.
                </p>
              </div>
              
              <div className="relative h-64 md:h-auto">
                <img
                  src="https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/e1681199f38bfd4b5f6cf6f1cdc9339b.jpeg"
                  alt="Premiações Agubel"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 md:mt-12 text-center">
          <div className="inline-flex items-center bg-green-100 px-6 py-3 md:px-8 md:py-4 rounded-full">
            <i className="ri-star-fill text-2xl md:text-3xl text-amber-500 mr-2 md:mr-3"></i>
            <p className="text-sm md:text-lg font-bold text-green-800">
              Reconhecimento Nacional e Internacional pela Qualidade dos Nossos Produtos
            </p>
            <i className="ri-star-fill text-2xl md:text-3xl text-amber-500 ml-2 md:ml-3"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
